// Styles Tailwind partagés par les 5 étapes du suivi comptable (ArrivePCStage,
// TriStage, Traitement1Stage, Traitement2Stage, BouclageStage), pour rester
// homogène avec ClotureStageModal.js (même zone Traitements/Suivi) et éviter
// de réinventer 5 jeux de classes différents.
export const inputCls =
  "w-full mt-1 px-3 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#840040]/20 focus:border-[#840040]";
export const textareaCls = `${inputCls} resize-none`;
export const labelCls = "text-xs font-medium text-gray-500";
export const cardCls = "border border-gray-100 rounded-2xl p-4 space-y-4";
export const subCardCls = "rounded-xl border border-gray-100 bg-gray-50/60 p-3.5 space-y-3";
export const cycleTitleCls = "text-xs font-bold text-[#5C1A30] uppercase tracking-wide";
